import moment from 'moment';

import { getUserLanguage } from 'utils/i18n';

export { Moment } from 'moment';

moment.locale(getUserLanguage());

export default moment;
